import { render, staticRenderFns } from "./GerenciamentoToken.vue?vue&type=template&id=d7c31e9a"
import script from "./GerenciamentoToken.vue?vue&type=script&lang=js"
export * from "./GerenciamentoToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports